module.exports = __webpack_public_path__ + "img/yg.fde16c1d.png";